import "@/index.css";
import "@/App.css";
import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import WhatWeDo from "@/pages/WhatWeDo";
import VPV from "@/pages/VPV";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import CaseStudy from "@/pages/CaseStudy";
import Insights from "@/pages/Insights";

// Static-zip builds use HashRouter so the site works on any hosting with no server config.
const Router = process.env.REACT_APP_HASH_ROUTER === "true" ? HashRouter : BrowserRouter;

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/work" element={<Work />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/vpv" element={<VPV />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/case-studies/:slug" element={<CaseStudy />} />
          </Route>
        </Routes>
      </Router>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
